import type { Position } from "./types";

export const SEAM_KEYS = [
    "porosityKern",
    "porosityGIS",
    "permeabilityKern",
    "permeabilityGis",
    "oilKern",
    "gasGis",
    "uesGis",
    "oilGis",
] as const;

type SeamKeys = (typeof SEAM_KEYS)[number];

export const SEAM_NAMING_MAP: Record<SeamKeys,string> = {
    porosityKern: 'Кп (керн)',
    porosityGIS: 'Кп (ГИС)',
    permeabilityKern: 'Кпр (керн)',
    permeabilityGis: 'Кпр (ГИС)',
    oilKern: 'Кнг (керн)',
    gasGis: 'Нэф.пр.',
    uesGis: 'УЭС',
    oilGis: 'Кнг (ГИС)',
}

export const positionTranslate: Record<Position, string> = {
    right: '',
    leftBottom: 'translateX(-100%)',
    leftTop: 'translateX(-100%) translateY(-100%)'
} 
